import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Slider from 'react-slick';
import { RouteNames } from 'router';
import { ProductBrowserAction } from 'modules/productBrowser/actions';
import { ProductBrowserSelector } from 'modules/productBrowser/selector';
import { ExploreButton } from 'components/atoms/exploreButton';
import HorizontalCarouselStatements from 'components/atoms/horizontalCarouselStatements';
import { PaginationControl } from 'components/molecules/paginationControl';
import ProductBrowserDetailsCard from 'components/molecules/productBrowserDetailsCard';
import { OverlayModal } from 'components/templates/overlayModal';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { useViewport } from 'components/templates/viewportProvider';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
//eslint-disable-next-line
import styles from "./styles.scss";

import {
  ProductIntro,
  ProductInProjectIntro,
  ProjectInProjectsIntro,
} from 'Mock/productBrowserMock';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

const ProductBrowserSlick = props => {
  const { productDescription, clearProductFilters, breadCrumb, type } = props;
  const { height } = useViewport();
  const products = props.productData;
  const isParams = props.isParam && Object.keys(props.isParam)[0];
  const [count, setCount] = useState({
    screenWidth: 0,
    ImageHeight: 0,
  });
  const [activeSlide, setActiveSlide] = useState(1);
  const [slider, setSlider] = useState();
  const [showProducts, setShowProducts] = useState(false);

  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);
    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
    };
  }, []);

  // clear project filters on unmount
  useEffect(() => {
    return () => {
      clearProductFilters();
    };
  }, []);

  const checkParamValue = () => {
    switch (isParams) {
      case 'projectSlug':
      case 'workspaceSlug':
        return ProductInProjectIntro;
      case 'productSlug':
        return ProjectInProjectsIntro;
      default:
        break;
    }
  };

  const isParticularProduct = !isParams ? ProductIntro : checkParamValue();
  const { heading, subHeading, description } = isParticularProduct;
  const subHeadingToDisplay = (type=="Workations") ? "Browse Offices by Products" : subHeading;

  const updateWindowDimensions = () => {
    const calculateHeight = (window.innerWidth * 8) / 19;
    setCount({
      ...count,
      screenWidth: window.innerWidth,
      ImageHeight: calculateHeight,
    });
  };

  const next = () => {
    slider.slickNext();
  };

  const previous = () => {
    slider.slickPrev();
  };

  // TODO Check why next slide is -1. Once checked, remove the conditional operator from 'beforechange'
  const settings = {
    className: ' slider variable-width',
    autoplay: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 1000,
    beforeChange: (current, next) => setActiveSlide(next + 1),
    arrows: false,
    draggable: true,
    cssEase: ' cubic-bezier(0.77, 0, 0.175, 1)',
  };

  const renderEachRows = product => {
    let renderRows = [];
    renderRows.push(
      <ProductBrowserDetailsCard data={product} count={count} key={0} type={type}/>
    );
    return renderRows;
  };

  const renderSliders = () => {
    let slides = [];
    if (products.length != null) {
      products.map((product, index) => {
        slides.push(
          <div
            key={index}
            className="carousel-slide"
            // style={{ width: count.screenWidth * 0.4 }}
          >
            {renderEachRows(product)}
          </div>
        );
      });

      return slides;
    }
  };

  const renderPagination = () => {
    const lengthOfSliders = products ? products.length : '';
    return (
      <div className="section-footer">
        <PaginationControl
          className={'section-footer-item'}
          theme={'dark-theme'}
          mode={'slider'}
          currentIndex={activeSlide}
          total={lengthOfSliders}
          onNextClick={next}
          onPreviousClick={previous}
          key={'10'}
        />
      </div>
    );
  };

  const showOverlay = showProducts ? (
    <OverlayPortal>
      <OverlayModal
        data={props.filteredProducts}
        activeFilters={props.activeFilters}
        theme={'dark-theme'}
        type={'products'}
        mediaPath={'mediaPath'}
        onClosePress={() => {
          setShowProducts(false);
          // props.clearProductFilters();
        }}
        breadcrumbList={[
          {
            breadcrumbName: breadCrumb ? breadCrumb : 'Homes',
            breadcrumbLink: RouteNames.homes,
          },
          {
            breadcrumbName: 'Product Browser',
            breadcrumbLink: '#',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  const renderContent = () => {
    return (
      <div className="project-browser">
        {/*{productDescription !== null ? (*/}
        {/*  <div*/}
        {/*    className={'description'}*/}
        {/*    dangerouslySetInnerHTML={{ __html: productDescription }}*/}
        {/*  />*/}
        {/*) : (*/}
        {/*  <HorizontalCarouselStatements*/}
        {/*    heading={heading}*/}
        {/*    subHeading={subHeading}*/}
        {/*    description={description}*/}
        {/*  />*/}
        {/*)}*/}
        <Row>
          <Col md={6} sm={9}>
            <div className="project-browser-info-card">
              <h2>{subHeadingToDisplay}</h2>
            </div>
          </Col>
          <Col md={3} sm={3}>
            <div className="project-explore-button">
              <ExploreButton
                onClick={e => setShowProducts(true)}
                text="EXPLORE ALL PRODUCTS"
              />
            </div>
          </Col>
        </Row>
        <div className="projects-list-carousel">
          <Slider
            ref={c => setSlider(c)}
            {...settings}
            style={{ height: '100%' }}
          >
            {renderSliders()}
          </Slider>
        </div>
      </div>
    );
  };

  const renderHeader = () => {
    return (
      <div>
        <div className="project-explore-button">
          <ExploreButton
            onClick={e => setShowProducts(true)}
            text="EXPLORE ALL PRODUCTS"
          />
        </div>
      </div>
    );
  };

  return (
    <div className="page-background" style={{ height }}>
      {/*TODO Check why section-container is hiding the renderContent    */}
      {renderContent()}
      <div className="section-container">
        {/*{renderHeader()}*/}
        {renderPagination()}
      </div>
      {showOverlay}
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const { project, productsSelector } = props;
  return {
    filteredProducts: ProductBrowserSelector.getFilteredProducts(
      state,
      project ? project.id : null,
      productsSelector
    ),
    activeFilters: ProductBrowserSelector.getActiveProductFilterNames(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { clearProductFilters } = ProductBrowserAction;
  return bindActionCreators(
    {
      clearProductFilters,
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductBrowserSlick)
);
